import React, {useEffect, useState} from 'react'
import MyChildHeader from './MyChildHeader'
import { Link } from "react-router-dom";
import Project from '../Project/Project'
import CUV from '../MyChild/CUV'

import childBorder from 'assets/img/child-border.jpg'
import Main from '../../Main'
//import VideoModal from '../../shared/Modal'
import Modal from '../../shared/Modal';
import VideoModal2 from '../../shared/Modal'
import swal from "sweetalert2";

const styles = {
  img: {
    background: 'url(' + childBorder + ')',
    backgroundSize: 'cover',
    padding: '11px 6px',
    border: 'none',
    backgroundRepeat: 'no-repeat'
  }
}

const MyChild = props => {

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

  let d = new Date()

  if (typeof props.child !== 'undefined') {
    let bday = props.child.birthdate.split(' ');
    // d = new Date(props.child.birthdate)
    d = new Date(bday[0])
  }

  const curr_date = d.getDate()
  const curr_month = d.getMonth() //Months are zero based
  const curr_year = d.getFullYear()

  const theDate = monthNames[curr_month] + ' ' + curr_date + ', ' + curr_year

  function getDate() {
    if(typeof monthNames[curr_month] !== 'undefined')
      return theDate;
  }

  function getAge() {
    if (props.child.birthdate !== 'null') {
      if (isNaN(calculate_age(d))) {
        return ''
      } else {
        return calculate_age(d)
      }
    }
  }

  function calculate_age(dob) { 
    var diff_ms = Date.now() - dob.getTime();
    var age_dt = new Date(diff_ms); 

    return Math.abs(age_dt.getUTCFullYear() - 1970);
  }

  // const showAdvisory = () => {
  //     swal.fire(
  //         "ADVISORY",
  //         "For safety precaution, sponsorship visits are unavailable until May 31, 2020. Thank you!",
  //         "info"
  //     )
  // }

  function childLinkBtn()
  {
    // var today = new Date();
    // var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    // var date = '2020-3-32';

    // if (date < '2020-3-32') {
    //   return <button className="mt-17 btn visit-child-button" onClick={showAdvisory}>Visit my Child</button>;
    // } else {
      // return (
      //   <Link
      //       to={`/dashboard/visit-my-child/${props.child.child_id}`}
      //       title="Visit my child"
      //       className="mt-17 btn visit-child-button"
      //   >
      //       Visit my Child
      //   </Link>
      // )
    // }
  }

  // 2022
  function downloadVideo(){
    // let check_link = WebService.downloadVideo(props.child.child_id).then(data => {
    //   return data;
    // })

    const childId = props.child.child_id;

    const apiUrl = process.env.REACT_APP_API_URL;

    let resourceUrl = apiUrl + "/web/v3/download_cuv/" + childId;

    const link = document.createElement('a');
    link.href = resourceUrl;
    link.setAttribute('download', 'download.mp4'); //or any other extension
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  return (
    <Main>
      <div className="site-mychild">
        <MyChildHeader 
          handler={props.handler}
          prevChild={props.prevChild} 
          nextChild={props.nextChild}
          sponsorName={props.sponsor.salutation || undefined}
          childPhoto={props.childPhoto || undefined}
          childVideoSolo={props.childVideoSolo || undefined}
          child={props.child || undefined} />

        <div className="donor-body">
          <div className="row">
            <div className="donor-child donor-child-block col-sm-8">
              <div className="island">
                <div className="child-image-region row">

                  <div className="multi-media col-sm-5">
                    <div id="child_carousel" className="donor-carousel-block carousel slide" data-ride="carousel">
                      <div className="carousel-inner" role="listbox">
                        <div className="child-portrait item image-item active">
                          <img className="img-responsive" src={props.childPhoto} alt="child portrait" style={styles.img} />

                          {/* ---------------------------------- Visit Child Link -------------------------------- */}
                          {childLinkBtn()}
                          {/* <Link
                              to={`/dashboard/visit-my-child/${props.child.child_id}`}
                              title="Visit my child"
                              className="mt-17 btn visit-child-button"
                          >
                              Visit my Child
                          </Link> */}

                       

                          {/* <button className="mt-17 btn visit-child-button" onClick={showAdvisory}>Visit my Child</button> */}
                          {/* ------------------------------------------------------------------------------------ */}
                              {/* ---------------------------------- CUV Link -------------------------------- */}

                              
                        </div>

                        {/* <CUV childPhoto={props.childPhoto}  /> */}


                        {
                          props.childVideo.length > 0
                          &&
                          <Modal 
                            content={props.childVideo[2].url} 
                            type="video" 
                            el="link" 
                            rating_type="cgv" 
                            rating_target={props.childVideo[2].key} 
                            rating_meta={{
                              child_id: props.child.child_id, 
                              target: props.childVideo[2].key, 
                              content: props.childVideo[2].url
                            }} 
                          />
                        }
                       
                        {
                           props.childVideoSolo.length > 0
                           &&
                           <>
                          <Modal
                            content={props.childVideoSolo[2].url}  
                            type="cuv" 
                            el="cuv" 
                            rating_type="cuv" 
                            rating_target={props.childVideoSolo[2].url} 
                            rating_meta={{
                              child_id: props.child.child_id, 
                              target: props.childVideoSolo[2].key, 
                              content: props.childVideoSolo[2].url
                            }} 
                          /> 
                          
                          {/* <button type="button" style={{marginTop: '10px'}} className="btn btn-sm" onClick={downloadVideo}>
                            <i className="fa fa-download" style={{marginRight: '10px'}}></i>Download
                          </button> */}

                          <Modal
                            content={props.childVideoSolo[2].url}  
                            type="link" 
                            el="share_link"
                          /> 
                          </>
                          //  update 2022
                        }

                      </div>
                    </div>
                  </div>



                  <div className="col-sm-7">
                    <div className="child-facts child-page">
                      <h2 className="pastel_font child_header_title">Hello My name is {props.child.given_name}</h2>
                      <span className="pastel_font sub_header green_color">I am {getAge()} Years old</span><br/>
                      <span className="pastel_font sub_header green_color">I live in {props.project.project_name}</span><br/>
                      <span className="pastel_font sub_header green_color">I was born on {getDate()}</span><br/>

                      <div>
                        <span className="pastel_font sub_header green_color label">Grade Level</span>
                        <span className="pastel_font sub_header green_color">{props.child.school_level}</span>
                      </div>

                      <div>
                        <span className="pastel_font sub_header green_color label">My favorite subject</span>
                        <span className="pastel_font sub_header green_color">{props.child.favorite_subject}</span>
                      </div>

                      <div>
                        <span className="pastel_font sub_header green_color label">My favorite play</span>
                        <span className="pastel_font sub_header green_color">{props.child.favorite_play}</span>
                      </div>

                      <div className="child-greeting">
                        {props.child.paragraph_body}
                      </div>

                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div className="donor-right-column donor-column col-sm-4">
              {/* Community: {props.child.video_url || undefined} */}
              <Project childVideo={props.child.video_url || undefined} childFirstName={props.child.given_name || undefined} project={props.project} />
            </div>

          </div>
        </div>

      </div>
    </Main>
  )
}

export default MyChild
